<script setup lang="ts">
import { ref } from 'vue';
import useLocale from './helpers/use-locale';

type Props = {
  rounded?: 'sm' | 'default' | 'lg';
  bgColor?: string;
};
type Emits = {
  (e: 'onSearch', search: string): void;
};

withDefaults(defineProps<Props>(), { rounded: 'lg' });

const emit = defineEmits<Emits>();
const { t } = useLocale();

const search = ref();

const onSearch = () => {
  emit('onSearch', search.value);
};

const clear = () => {
  search.value = '';
  onSearch();
};
</script>

<template>
  <v-text-field
    id="search-input"
    v-model="search"
    type="search"
    :label="t('components.input_search')"
    prepend-inner-icon="mdi-magnify"
    single-line
    variant="solo"
    hide-details
    class="search-input"
    :bg-color="bgColor"
    :clearable="true"
    :rounded="rounded === 'default' ? 'true' : rounded"
    color="primary"
    :aria-label="t('components.input_search')"
    aria-describedby="search-input"
    @update:modelValue="onSearch"
    @keyup.enter="onSearch"
    @click:clear="clear"
  >
    <template #label>
      <span>{{ t('components.input_search') }}</span>
    </template>
  </v-text-field>
</template>

<style scoped lang="scss">
:deep(.v-field__field) {
  max-height: 48px !important;
}

:deep(.v-field) {
  box-shadow: none;
}

:deep(.v-field--focused) {
  border: 2px solid rgb(var(--v-theme-primary));
  margin: -2px;
}

:deep(.v-field__input) {
  outline: none !important;
  padding-bottom: 10px !important;
  padding-top: 2px !important;
}
</style>
